import type * as React from "react";
import { cn } from "../../lib/cn";

export interface InputProps extends React.ComponentProps<"input"> {
  error?: boolean;
}

export function Input({
  className,
  type,
  error,
  "aria-invalid": ariaInvalid,
  ...props
}: InputProps) {
  const isInvalid = error || ariaInvalid === true || ariaInvalid === "true";

  return (
    <input
      type={type}
      aria-invalid={isInvalid ? true : undefined}
      className={cn(
        "flex h-10 w-full rounded-md border bg-container-default-background px-3 py-2 text-body-m-r placeholder:text-text-placeholder transition-colors duration-140 ease-emphasized focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        isInvalid
          ? "border-fail-text text-fail-text focus-visible:border-fail-text"
          : "border-container-default-border text-text focus-visible:border-[color:var(--focus-ring,var(--color-primary))]",
        className,
      )}
      {...props}
    />
  );
}
